
import React from 'react';

export const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: 'Maria Silva',
      company: 'Silva & Associados Ltda',
      role: 'Diretora Comercial',
      content: 'A Conte Assessoria transformou nossa gestão contábil. O atendimento personalizado e a proatividade da equipe nos deram total confiança para focar no crescimento da empresa. Recomendo sem hesitar!',
      rating: 5
    },
    {
      name: 'João Santos',
      company: 'TechStart Inovação',
      role: 'CEO',
      content: 'Como startup, precisávamos de um parceiro que entendesse nossas necessidades específicas. A Conte não só organizou nossa contabilidade como nos ajudou a economizar significativamente em impostos através do planejamento tributário.',
      rating: 5
    },
    {
      name: 'Ana Costa',
      company: 'Boutique Elegance',
      role: 'Proprietária',
      content: 'Há 5 anos com a Conte e só tenho elogios. O contador sempre disponível, relatórios claros e nunca perdemos um prazo. A organização que eles trouxeram para meu negócio foi fundamental para o sucesso.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-[#1A3A52]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-6 font-['Playfair_Display']">
            O Que Nossos Clientes Dizem
          </h3>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            A confiança dos nossos clientes é o nosso maior patrimônio
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-xl">
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C9A961] text-lg"></i>
                ))}
              </div>
              
              <blockquote className="text-gray-700 mb-6 leading-relaxed">
                "{testimonial.content}"
              </blockquote>
              
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#00A896] rounded-full flex items-center justify-center mr-4">
                  <span className="text-white font-semibold">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-[#1A3A52]">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                  <div className="text-sm text-[#00A896]">{testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-300 mb-6">
            Quer fazer parte dos nossos cases de sucesso?
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contato');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-[#C9A961] hover:bg-[#B8984F] text-[#1A3A52] px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-chat-3-line mr-2"></i>
            Fale Conosco Agora
          </button>
        </div>
      </div>
    </section>
  );
};
